import * as React from 'react';
import { cn } from '@/lib/utils';

/** Rounded 999px label shared by status pills, type and impact tags. Colour AND text, never colour alone. */
export function Pill({ className, ...props }: React.HTMLAttributes<HTMLSpanElement>) {
  return <span className={cn('inline-block whitespace-nowrap rounded-full px-2.5 py-[3px] text-xs font-bold', className)} {...props} />;
}
